import {Form, Formik} from "formik";
import ModalMsg from "../../components/ModalMsg";
import React from "react";
import Card from "../../components/card/Card";
import Translate from "../../components/Translate";
import NsField from "../../components/fields/NsField.jsx";

export default function AttivaAccountView({
                                              show,
                                              closeModal,
                                              modalMsg,
                                              formikRef,
                                              attivaAccount,
                                              formInitialValue,
                                              onClickGoToLogin,
                                              onChangePassword,
                                              onChangeConfirmPassword,
                                              getPasswordFooter,
                                              getConfirmPasswordFooter,
                                              passwordOk,
                                              password2Ok,
                                          }) {

    return (
        <Card
            icon={'fas fa-key'}
            title={'Completa la registrazione scegliendo la tua password'}
            //subtitle={'Una volta attivato l\'account, potrai accedere ai nostri servizi'}
        >
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <div className="ns-login ns-recupera-pwd">
                <Formik
                    initialValues={formInitialValue}
                    innerRef={formikRef}
                    onSubmit={attivaAccount}
                >
                    {({values, errors, touched, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-12">
                                <NsField
                                    name={"password"}
                                    label={"Password*:"}
                                    as={"password"}
                                    isRequired={true}
                                    formikRef={formikRef}
                                    onChange={onChangePassword}
                                    passwordShowFeedback={true}
                                    passwordFooter={getPasswordFooter}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-12">
                                <NsField
                                    name={"password2"}
                                    label={"Conferma password*:"}
                                    as={"password"}
                                    isRequired={true}
                                    formikRef={formikRef}
                                    onChange={onChangeConfirmPassword}
                                    passwordShowFeedback={true}
                                    passwordFooter={getConfirmPasswordFooter}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="d-grid gap-2">
                                <button type="submit" name="conferma" id="conferma"
                                        className="btn btn-dark"
                                        disabled={values["password"] === '' || values["password2"] === '' || values["password"] !== values["password2"] || !passwordOk || !password2Ok}>
                                    <i className="fas fa-check"/> <Translate>Conferma</Translate>
                                </button>
                                <button type="button"
                                        className="btn btn-dark"
                                        onClick={onClickGoToLogin}
                                >
                                    <i className="fas fa-sign-in-alt"/> <Translate>Vai alla log-in</Translate>
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Card>
    )
}
